import _ from 'lodash';
import Vue from 'vue';
import Router from 'vue-router';
// eslint-disable-next-line import/no-cycle
import store from '@/store';

// eslint-disable-next-line import/no-cycle
import lsTrackService from '@/services/ls-track/ls-track.service';

// Original - mydot
import GetPricing from '@/views/original-mydot/get-pricing/GetPricing.vue';
import SingleSignupParent from '@/views/original-mydot/single-signup-parent/SingleSignupParent.vue';
import SingleStepSignup from '@/views/original-mydot/single-step-signup/SingleStepSignup.vue';
import SingleStepSignupForm from '@/views/original-mydot/single-step-signup/SingleStepSignupForm.vue';
import PricingUnavailableForm from '@/views/original-mydot/pricing-unavailable/PricingUnavailableForm.vue';
import OutOfMarketForm from '@/views/original-mydot/out-of-market/OutOfMarketForm.vue';
import NonMowingForm from '@/views/original-mydot/non-mowing/NonMowingForm.vue';
import OneTimeMowingForm from '@/views/original-mydot/one-time-mowing/OneTimeMowingForm.vue';
import ThanksView from '@/views/original-mydot/thanks/ThanksView.vue';
// eslint-disable-next-line import/no-cycle
import { lsRouterHelpers } from './router.helpers';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: [
        // Single Step Signup - Original My. Design
        {
            // All nested under one parent to allow async loading in the future, if each individual path
            // has a single parent we can require clients to only load the path they have navigated to in the future
            path: '/single-signup',
            component: SingleSignupParent,
            children: [
                {
                    path: '',
                    name: 'getPricing',
                    meta: {
                        showOrderSummary: false,
                        showAddress: false,
                    },
                    component: GetPricing,
                },
                {
                    path: 'form',
                    component: SingleStepSignup,
                    children: [
                        {
                            path: '',
                            name: 'singleStepSignupForm',
                            meta: {
                                showOrderSummary: true,
                                showAddress: true,
                            },
                            component: SingleStepSignupForm,
                            beforeEnter: (toRoute, fromRoute, next) => {
                                lsRouterHelpers.singleStepSignupFormBeforeEnter({
                                    fromRoute,
                                    next,
                                });
                            },
                        },
                        {
                            path: 'pricing-unavailable',
                            name: 'pricingUnavailableForm',
                            meta: {
                                showOrderSummary: false,
                                showAddress: true,
                            },
                            component: PricingUnavailableForm,
                        },
                        {
                            path: 'out-of-market',
                            name: 'outOfMarketForm',
                            meta: {
                                showOrderSummary: false,
                                showAddress: true,
                            },
                            component: OutOfMarketForm,
                        },
                        {
                            path: 'non-mowing',
                            name: 'nonMowingForm',
                            meta: {
                                showOrderSummary: false,
                                showAddress: true,
                                showFAQ: false,
                            },
                            component: NonMowingForm,
                        },
                        {
                            path: 'one-time-mowing',
                            name: 'oneTimeMowingForm',
                            meta: {
                                showOrderSummary: false,
                                showAddress: true,
                            },
                            component: OneTimeMowingForm,
                        },
                        {
                            path: 'thanks/:variant?',
                            name: 'thanks',
                            meta: {
                                showOrderSummary: false,
                                showAddress: true,
                            },
                            component: ThanksView,
                        },
                    ],
                },
            ],
        },
        // end Single Step Signup

        // End all redirect
        {
            path: '*',
            redirect: '/single-signup',
        },
    ],
});

// Before Each hooks
// Route guards will not load on query / param changes on base route
router.beforeEach((toRoute, fromRoute, next) => {
    // RETRIEVE ENGAGEMENT ID
    const engagement_id = _.get(toRoute, 'query.eid');
    if (engagement_id) {
        // RECORD ENGAGEMENT ID
        lsTrackService.setEngagementId(engagement_id);
    }

    next();
});

router.beforeEach((toRoute, fromRoute, next) => {
    const orderId = _.get(store, 'state.order.order_id');
    const { meta, params, query } = toRoute;

    // Redirect to get pricing if no order exists in store and short circuit
    if (!orderId && toRoute.name !== 'getPricing') {
        router.push({
            name: 'getPricing',
            meta,
            params,
            query,
        });
    } else {
        next();
    }
});

router.beforeEach((toRoute, fromRoute, next) => {
    const { name, meta, params, query } = toRoute;

    if (_.size(toRoute.query)) {
        // keep any query params from being visible to users, just use route params object
        _.assign(params, query);
        _.forEach(query, (value, key) => {
            delete query[key];
        });
        // delete toRoute.query;
        // if query, set as params for access in component without visibility in url
        next({
            name,
            meta,
            params,
            query,
        });
    } else {
        next();
    }
});

// scroll to top on route change
router.beforeEach((toRoute, fromRoute, next) => {
    window.scrollTo(0, 0);
    next();
});

let referrer = '';
router.afterEach((toRoute, fromRoute) => {
    if (!fromRoute.name) {
        referrer = _.get(document, 'referrer');
    }
    lsTrackService.track({ type: 'transitionedTo' });
    lsTrackService.page({ path: toRoute.path, referrer });
});

export default router;
